import ability from './ability'
import axios from '@axios'
export const canNavigate = to => to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))

export const registerEnabled = () => {
    return new Promise((resolve, reject) => {
        axios
            .post('/settings/register-enabled')
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}

export const _ = undefined